import { graphql } from "../generated/gql";

export const GetTagsAndNotes = graphql(
  `
  query GetTagsAndNotes($callId: ID!) {
    getTagsAndNotes(callId: $callId) {
      __typename
      notes {
        callId
        companyId
        content
        createdAt
        firstName
        id
        lastName
        userId
      }
      tags {
        ...Tag
      }
    }
  }
  `
);
